import { DestinationFilterBase } from './destinationFilterBase';
import { TrackedPage } from '../trackedpages';
import { TrackedEvent } from '../trackedEvent';

export class ActiveCampaignDestinationFilter extends DestinationFilterBase {
    public destinationName = 'ActiveCampaign';

    public supportedEvents = [] as TrackedEvent[];

    public supportedPages = [] as TrackedPage[];
}
